'use client';
import { Image } from '@akinon/next/components/image';

import { Link } from '@theme/components';
import { ErrorPageType } from './not-found';
import { CategoryCarouselType } from '@theme/widgets/category-carousel';
import { useGetWidgetQuery } from '@akinon/next/data/client/misc';
import CategoryCarouselContent from '@theme/views/widgets/category-carousel-content';

export default function Error() {
  const { data } = useGetWidgetQuery('acc-500-error-page');
  const { data: categoryCarouselData } = useGetWidgetQuery(
    'homepage-category-carousel'
  );

  if (!data || !categoryCarouselData) {
    return (
      <>
        <div className="relative min-h-[500px]">
          <div className="absolute flex flex-col items-center justify-center top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-center z-10 w-full max-w-[21.875rem] lg:max-w-[28rem]">
            <div className="h-12 w-3/4 bg-gray-200 animate-pulse rounded-md mb-4"></div>
            <div className="h-8 w-full bg-gray-200 animate-pulse rounded-md mb-6"></div>
            <div className="space-y-2 w-full">
              <div className="h-4 w-full bg-gray-200 animate-pulse rounded-md"></div>
              <div className="h-4 w-5/6 bg-gray-200 animate-pulse rounded-md"></div>
              <div className="h-4 w-4/6 bg-gray-200 animate-pulse rounded-md"></div>
            </div>
            <div className="h-12 w-40 bg-gray-200 animate-pulse rounded-full mt-6"></div>
          </div>
          <div className="w-full h-full aspect-[390/620] lg:aspect-[1680/850] bg-gray-200 animate-pulse"></div>
        </div>
        <div className="lg:pt-[4rem] pt-[5.4rem] lg:px-[5%]">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {[...Array(4)].map((_, index) => (
              <div
                key={index}
                className="aspect-[390/620] bg-gray-200 animate-pulse rounded-md"
              ></div>
            ))}
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <div className="relative">
        <div className="absolute flex flex-col items-center justify-center top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-center z-10 w-full max-w-[21.875rem] lg:max-w-[28rem]">
          <h1 className="lg:text-5xl text-[2rem] font-medium text-white mb-[1.125rem]">
            {data?.attributes?.error_status?.value}
          </h1>
          {data?.attributes?.title?.value && (
            <h2 className="mb-4  text-lg lg:text-xl font-medium text-white">
              {data?.attributes?.title?.value}
            </h2>
          )}
          {data?.attributes?.description?.value && (
            <div
              className="text-white mb-4"
              dangerouslySetInnerHTML={{
                __html: data?.attributes?.description?.value
              }}
            />
          )}
          <Link
            href={data?.attributes?.link_path?.value ?? '/'}
            className="bg-white rounded-full py-[15px] px-[22px] text-primary-black text-sm"
          >
            {data?.attributes?.link_label?.value}
          </Link>
        </div>

        {data?.attributes?.bg_image?.kwargs?.url && (
          <Image
            src={data?.attributes?.bg_image?.kwargs?.url}
            alt={data?.attributes?.alt?.value ?? ''}
            width={1920}
            height={1080}
            className="w-full h-full aspect-[390/620] lg:aspect-[1680/850]"
            imageClassName="w-full object-cover object-center h-full"
          />
        )}
      </div>
      <div className="lg:pt-[4rem] pt-[5.4rem] lg:px-[5%]">
        <CategoryCarouselContent
          attributes={categoryCarouselData?.attributes}
        />
      </div>
    </>
  );
}
